import { useContext, useState } from 'react';
import { FaArrowUp, FaEquals } from 'react-icons/fa';
import { Link, NavLink } from 'react-router-dom';
import { authUser } from '../Context/UserContext';


const Navbar = () => {
    const { user, logutOut } = useContext(authUser)
    const [open, setOpen] = useState(false);
    return (
        <nav className="sticky top-0 z-50">
            <div className="  bg-[rgb(33,33,33)]  h-20 flex shadow-2xl   " >
                <div className="h-20 flex  items-center pl-5 md:pl-10">
                    <Link to='/' className="btn btn-ghost normal-case text-2xl text-red-500">Educapedia</Link>
                </div>
                <div className="md:hidden flex  items-center justify-end w-full h-20 px-10 " onClick={() => setOpen(!open)}>
                    {open ? <FaArrowUp className='flex items-center' /> : <FaEquals />}
                </div>
                <div className={` md:flex justify-end absolute md:static   w-full  md:h-20 text-center bg-[rgb(33,33,33)] items-center  text-yellow-200
            md:my-0 my-8 pb-3 md:w-3/4  md:pr-10 pt-4
            ${open ? 'top-6' : 'top-[-240px]'}`}
                >
                    <NavLink className='hover:text-gray-400 ' to='/home'><ul>Home</ul></NavLink>
                    <NavLink className='ml-5 hover:text-gray-400' to='/courses'><ul>Courses</ul></NavLink>
                    <NavLink className='ml-5 hover:text-gray-400' to='/blog'><ul>Blog</ul></NavLink>
                    <label className="swap swap-rotate md:ml-5  hover:text-indigo-400 pt-5 md:pt-0">
                        <input type="checkbox" />
                        <svg className="swap-on fill-current w-7 h-10" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5.64,17l-.71.71a1,1,0,0,0,0,1.41,1,1,0,0,0,1.41,0l.71-.71A1,1,0,0,0,5.64,17ZM5,12a1,1,0,0,0-1-1H3a1,1,0,0,0,0,2H4A1,1,0,0,0,5,12Zm7-7a1,1,0,0,0,1-1V3a1,1,0,0,0-2,0V4A1,1,0,0,0,12,5ZM5.64,7.05a1,1,0,0,0,.7.29,1,1,0,0,0,.71-.29,1,1,0,0,0,0-1.41l-.71-.71A1,1,0,0,0,4.93,6.34Zm12,.29a1,1,0,0,0,.7-.29l.71-.71a1,1,0,1,0-1.41-1.41L17,5.64a1,1,0,0,0,0,1.41A1,1,0,0,0,17.66,7.34ZM21,11H20a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Zm-9,8a1,1,0,0,0-1,1v1a1,1,0,0,0,2,0V20A1,1,0,0,0,12,19ZM18.36,17A1,1,0,0,0,17,18.36l.71.71a1,1,0,0,0,1.41,0,1,1,0,0,0,0-1.41ZM12,6.5A5.5,5.5,0,1,0,17.5,12,5.51,5.51,0,0,0,12,6.5Zm0,9A3.5,3.5,0,1,1,15.5,12,3.5,3.5,0,0,1,12,15.5Z" /></svg>
                        <svg className="swap-off fill-current w-7 h-10" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21.64,13a1,1,0,0,0-1.05-.14,8.05,8.05,0,0,1-3.37.73A8.15,8.15,0,0,1,9.08,5.49a8.59,8.59,0,0,1,.25-2A1,1,0,0,0,8,2.36,10.14,10.14,0,1,0,22,14.05,1,1,0,0,0,21.64,13Zm-9.5,6.69A8.14,8.14,0,0,1,7.08,5.22v.27A10.15,10.15,0,0,0,17.22,15.63a9.79,9.79,0,0,0,2.1-.22A8.11,8.11,0,0,1,12.14,19.73Z" /></svg>
                    </label>
                </div>
                <div className="mx-auto flex items-center pr-10 ">
                    {user ?
                        <div className="tooltip tooltip-left " data-tip={user?.displayName}>
                            <div className="dropdown dropdown-end">
                                <label tabIndex={0} className="btn btn-ghost btn-circle avatar ">
                                    <div className="w-10 rounded-full">
                                        <img src={user?.photoURL} alt='img' />
                                    </div>
                                </label>
                                <ul tabIndex={0} className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-400 rounded-box w-52">
                                    <button className=' text-red-400' onClick={logutOut}>Logout</button>
                                </ul>
                            </div>
                        </div>
                        : <Link to='/login'><button className='btn btn-warning btn-outline mx-3'>Login</button></Link>}
                </div>
            </div>
        </nav>
    );
};

export default Navbar;